import DateHelpers from './DateHelpers';

class Talent {
  constructor(params) {
    Object.keys(params).forEach((attr) => {
      this[attr] = params[attr];
    });
  }

  hasAppliedRecently() {
    const appliedDiffInS = DateHelpers.differenceBetweenTimeStampsInS(
      Date.now(),
      this.most_recent_application,
    );
    return Math.round(appliedDiffInS / (60 * 60 * 24)) < 30;
  }
}

export default Talent;
